/**
 * @generated SignedSource<<7d44d9d0909d994e77711e14344b7bbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubSchoolModelSchoolTypeChoices = "PRIMARY" | "PRIMARY_AND_SECONDARY" | "SECONDARY" | "%future added value";
export type EditSchoolInput = {
  addressFirstLine?: string | null | undefined;
  addressSecondLine?: string | null | undefined;
  archived?: boolean | null | undefined;
  city?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  deleteSchool?: boolean | null | undefined;
  headTeacherEmail?: string | null | undefined;
  headTeacherFirstName?: string | null | undefined;
  headTeacherLastName?: string | null | undefined;
  headTeacherPhoneNumber?: string | null | undefined;
  mainOfficeContactEmail?: string | null | undefined;
  mainOfficeContactFirstName?: string | null | undefined;
  mainOfficeContactLastName?: string | null | undefined;
  mainOfficeContactPhoneNumber?: string | null | undefined;
  name?: string | null | undefined;
  otherContactEmail?: string | null | undefined;
  otherContactFirstName?: string | null | undefined;
  otherContactIndex?: number | null | undefined;
  otherContactLabel?: string | null | undefined;
  otherContactLastName?: string | null | undefined;
  otherContactPhoneNumber?: string | null | undefined;
  postcode?: string | null | undefined;
  schoolId: string;
  schoolType?: string | null | undefined;
  website?: string | null | undefined;
};
export type EditSchoolMutation$variables = {
  connections: ReadonlyArray<string>;
  input: EditSchoolInput;
};
export type EditSchoolMutation$data = {
  readonly editSchool: {
    readonly deletedSchoolId: string | null | undefined;
    readonly errors: any | null | undefined;
    readonly school: {
      readonly archived: boolean;
      readonly headTeacher: {
        readonly hasInvalidPhoneNumber: boolean;
        readonly id: string;
        readonly phoneNumber: string | null | undefined;
        readonly user: {
          readonly email: string;
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly id: string;
      readonly mainOfficeContact: {
        readonly addressFirstLine: string | null | undefined;
        readonly addressSecondLine: string | null | undefined;
        readonly city: string | null | undefined;
        readonly hasInvalidPhoneNumber: boolean;
        readonly id: string;
        readonly phoneNumber: string | null | undefined;
        readonly postcode: string | null | undefined;
        readonly user: {
          readonly email: string;
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
        };
      } | null | undefined;
      readonly name: string;
      readonly otherContacts: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly hasInvalidPhoneNumber: boolean;
            readonly id: string;
            readonly label: string | null | undefined;
            readonly phoneNumber: string | null | undefined;
            readonly user: {
              readonly email: string;
              readonly firstName: string;
              readonly id: string;
              readonly lastName: string;
            };
          } | null | undefined;
        } | null | undefined>;
      };
      readonly schoolType: PianofunclubSchoolModelSchoolTypeChoices;
      readonly website: string | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type EditSchoolMutation = {
  response: EditSchoolMutation$data;
  variables: EditSchoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedSchoolId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvalidPhoneNumber",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "DjangoUserNode",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SchoolNode",
  "kind": "LinkedField",
  "name": "school",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schoolType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNode",
      "kind": "LinkedField",
      "name": "headTeacher",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNode",
      "kind": "LinkedField",
      "name": "mainOfficeContact",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "addressFirstLine",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "addressSecondLine",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postcode",
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileNodeConnection",
      "kind": "LinkedField",
      "name": "otherContacts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProfileNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                (v9/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditSchoolMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "EditSchoolPayload",
        "kind": "LinkedField",
        "name": "editSchool",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditSchoolMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "EditSchoolPayload",
        "kind": "LinkedField",
        "name": "editSchool",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedSchoolId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20bfc2376f53c346f02f513acbfdfad2",
    "id": null,
    "metadata": {},
    "name": "EditSchoolMutation",
    "operationKind": "mutation",
    "text": "mutation EditSchoolMutation(\n  $input: EditSchoolInput!\n) {\n  editSchool(input: $input) {\n    success\n    errors\n    deletedSchoolId\n    school {\n      id\n      name\n      archived\n      schoolType\n      website\n      headTeacher {\n        id\n        phoneNumber\n        hasInvalidPhoneNumber\n        user {\n          id\n          firstName\n          lastName\n          email\n        }\n      }\n      mainOfficeContact {\n        id\n        phoneNumber\n        hasInvalidPhoneNumber\n        addressFirstLine\n        addressSecondLine\n        city\n        postcode\n        user {\n          id\n          firstName\n          lastName\n          email\n        }\n      }\n      otherContacts {\n        edges {\n          node {\n            id\n            phoneNumber\n            hasInvalidPhoneNumber\n            label\n            user {\n              id\n              firstName\n              lastName\n              email\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd4d8b82864f36b648156f3d51d3dac6";

export default node;
